
/**
 * External link to the club's Sports360 open plays page.
 *
 * Sports360 is fronted by Cloudflare Bot Management which intermittently
 * blocks cross-site navigations from our domain. We therefore route the
 * click through a same-origin intermediate page (`/op`) that strips the
 * Referer header and then redirects the user to Sports360. This makes the
 * outgoing navigation look identical to a fresh URL paste.
 */
const OpenPlaysLink = ({ className = "" }) => (
  <a
    href="/op"
    target="_blank"
    rel="noopener noreferrer"
    data-testid="open-plays-link"
    title="Open Plays on Sports360"
    aria-label="Open Plays on Sports360"
    className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 text-xs sm:text-sm font-bold text-[#8cc63f] border border-[#8cc63f]/50 rounded-sm hover:bg-[#8cc63f] hover:text-black transition-colors ${className}`}
  >
    <img
      src="https://customer-assets.emergentagent.com/job_court-reserve-54/artifacts/3apmhov4_sports360-logo-login-Cd80Vo2N.png"
      alt=""
      aria-hidden="true"
      className="w-5 h-5 rounded-sm object-contain"
    />
    <span className="whitespace-nowrap">OP</span>
  </a>
);

export default OpenPlaysLink;
